/**
 * NovaFrozen — "Frozen" persona tile. Covered in ice. Still floating. Barely.
 * Timing: 0.25s shiver · 4s snowfall. Geometry generated from the canonical Character
 * Bible catalog (nova.js) — regenerate rather than hand-editing paths.
 * Animations come from nova.css via the `expr-frozen` wrapper class
 * (applied by <NovaExpression id="frozen" />).
 */
import * as React from "react";

export function NovaFrozen({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nova frozen in ice">
      <g className="frozen-shiver">
        
        
      <defs>
        <linearGradient id="bodyG-n2" x1="0.15" y1="0" x2="0.85" y2="1">
          <stop offset="0" stopColor="#709c9e"/>
          <stop offset="0.45" stopColor="#2D6E70"/>
          <stop offset="1" stopColor="#1e494a"/>
        </linearGradient>
        <linearGradient id="chestG-n2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#174143"/>
          <stop offset="1" stopColor="#3a6b6d"/>
        </linearGradient>
        <radialGradient id="scrG-n2" cx="0.5" cy="0.45" r="0.8">
          <stop offset="0" stopColor="#0E1626"/>
          <stop offset="0.72" stopColor="#0E1626"/>
          <stop offset="1" stopColor="#060A12"/>
        </radialGradient>
        <pattern id="pxg-n2" width="9" height="9" patternUnits="userSpaceOnUse">
          <path d="M 9 0 L 0 0 0 9" fill="none" stroke="#060A12" strokeWidth="1.6" opacity="0.65"/>
        </pattern>
        <filter id="eglow-n2" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="6"/>
        </filter>
      </defs>
        <g transform="translate(50 0)">
        
        
        <g className="nova-body" style={{ transformOrigin: "180.00px 472.00px" }} transform="rotate(0 180 347)">
          {/* Antenna stem (drawn first so head covers its base) */}
          <line x1="180" y1="122" x2="162.72677665418374" y2="44.72088514389387" stroke="#1C1A17" strokeWidth="2.2" strokeLinecap="round"/>
          {/* Orbital ring (behind ball, ivory) */}
          <ellipse cx="162.72677665418374" cy="44.72088514389387" rx="15" ry="5.3999999999999995" stroke="#F4EFE6" strokeWidth="1.6" fill="none" transform="rotate(-12 162.72677665418374 44.72088514389387)"/>
          {/* Antenna ball */}
          <circle className="antenna-ball" cx="162.72677665418374" cy="44.72088514389387" r="7" fill="#D4541F"/>
          <ellipse cx="160.62677665418374" cy="42.270885143893864" rx="2.94" ry="2.1" fill="#FFFFFF" opacity="0.55"/>
          {/* Front half of orbital ring (over ball) so it appears to encircle */}
          <path d="M 148.02677665418375 45.22088514389387 A 15 5.3999999999999995 -12 0 0 177.42677665418373 42.520885143893864"
                stroke="#F4EFE6" strokeWidth="1.6" fill="none" opacity="0.95"/>
          
    
          {/* HEAD outer (glossy) */}
          <rect x="60" y="110" width="240" height="170" rx="36" fill="url(#bodyG-n2)"/>
          {/* Bezel inset (darker ring) */}
          <rect x="82" y="132" width="196" height="126" rx="28" fill="#1F5759"/>
          {/* Face screen: recessed navy display */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#scrG-n2)"/>
    
          {/* Cheeks (on teal head, flanking screen) */}
          
    
          {/* Eyes: glow pass + sharp pass */}
          <g filter="url(#eglow-n2)" opacity="0.75">
          <g className="eye-left"><rect x="122.42699999999999" y="190.611" width="48.906000000000006" height="8.778" rx="4.389" fill="#A8C8E8" opacity="0.7"/></g>
          <g className="eye-right"><rect x="188.667" y="190.611" width="48.906000000000006" height="8.778" rx="4.389" fill="#A8C8E8" opacity="0.7"/></g>
        </g>
          
          <g className="eye-left"><rect x="122.42699999999999" y="190.611" width="48.906000000000006" height="8.778" rx="4.389" fill="#A8C8E8" opacity="0.7"/></g>
          <g className="eye-right"><rect x="188.667" y="190.611" width="48.906000000000006" height="8.778" rx="4.389" fill="#A8C8E8" opacity="0.7"/></g>
        
    
          {/* Single quiet tear (Sad) — on face screen, below right eye */}
          
    
          {/* Pixel grid over the display (LED look) */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#pxg-n2)"/>
          {/* Screen glare */}
          <ellipse cx="146.88" cy="148" rx="55.199999999999996" ry="9" fill="#8FB4E8" opacity="0.13"/>
          {/* Head specular */}
          <ellipse cx="112" cy="126" rx="36" ry="9" fill="#FFFFFF" opacity="0.35" transform="rotate(-10 112 126)"/>
    
          {/* BODY outer (glossy) */}
          <rect x="50" y="302" width="260" height="170" rx="36" fill="url(#bodyG-n2)"/>
          {/* Chest storage: interior + items behind a hinged door */}
          <rect x="72" y="324" width="216" height="126" rx="26" fill="#0B1220"/>
          <g className="chest-items" style={{ opacity: "0" }}>
            <path d="M 141.12 358 l 6.2 12.7 13.9 2 -10 9.8 2.4 13.9 -12.5 -6.6 -12.5 6.6 2.4 -13.9 -10 -9.8 13.9 -2 Z" fill="#D4A02C"/>
            <g transform="translate(190.8 368)">
              <rect x="0" y="0" width="44" height="30" rx="5" fill="#1C1A17"/>
              <circle cx="22" cy="15" r="9" fill="#3A3733" stroke="#F4EFE6" strokeWidth="1.4"/>
              <rect x="31" y="3" width="8" height="5" rx="1.5" fill="#3A3733"/>
            </g>
          </g>
          {/* Chest door (hinged at left edge) */}
          <g className="chest-door" style={{ transformOrigin: "74px 387.0px" }}>
            <rect x="72" y="324" width="216" height="126" rx="26" fill="url(#chestG-n2)"/>
            <line x1="79" y1="336" x2="79" y2="438" stroke="#0B1220" strokeWidth="2.4" opacity="0.55"/>
            <circle cx="272" cy="387.0" r="5" fill="#6d9293"/>
          </g>
          {/* Body specular */}
          <ellipse cx="98" cy="316" rx="30" ry="7" fill="#FFFFFF" opacity="0.25" transform="rotate(-8 98 316)"/>
    
          {/* Arms (drawn over body) */}
          
          <g className="float-arm float-arm-l">
            <rect x="8" y="326" width="30" height="96" rx="15" fill="url(#bodyG-n2)"/>
            <ellipse cx="18" cy="339" rx="7" ry="4" fill="#FFFFFF" opacity="0.32"/>
          </g>
          <g className="float-arm float-arm-r">
            <rect x="322" y="326" width="30" height="96" rx="15" fill="url(#bodyG-n2)"/>
            <ellipse cx="332" cy="339" rx="7" ry="4" fill="#FFFFFF" opacity="0.32"/>
          </g>
        
        </g>
        </g>
      
        <g transform="translate(50 0)">
          {/* snow cap on head + antenna ball */}
          <path d="M 92 116 Q 180 88 268 116 L 268 128 Q 180 104 92 128 Z" fill="#FFFFFF" opacity="0.85"/>
          <circle cx="180" cy="28" r="7" fill="#FFFFFF" opacity="0.8"/>
          {/* ice block encasing her */}
          <g>
            <rect x="34" y="88" width="292" height="352" rx="30" fill="#A8C8E8" opacity="0.38"/>
            <rect x="34" y="88" width="292" height="352" rx="30" fill="none" stroke="#D8ECFF" strokeWidth="3" opacity="0.75"/>
            {/* facet lines */}
            <path d="M 60 130 L 110 96" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
            <path className="ice-glint" d="M 250 120 L 305 160" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round"/>
            <path d="M 70 380 L 120 420" stroke="#D8ECFF" strokeWidth="3" strokeLinecap="round" opacity="0.4"/>
            {/* icicles under the block */}
            <path d="M 80 440 l 9 24 l 9 -24 Z" fill="#A8C8E8" opacity="0.8"/>
            <path d="M 150 440 l 11 32 l 11 -32 Z" fill="#A8C8E8" opacity="0.85"/>
            <path d="M 236 440 l 8 20 l 8 -20 Z" fill="#A8C8E8" opacity="0.75"/>
            <path d="M 292 440 l 10 27 l 10 -27 Z" fill="#A8C8E8" opacity="0.8"/>
          </g>
        </g>
      </g>
      {/* falling snowflakes (outer coords) */}
      <g stroke="#D8ECFF" strokeWidth="2.4" strokeLinecap="round">
        <g className="frozen-flake"><path d="M 90 10 l 0 12 M 84 16 l 12 0 M 86 12 l 8 8 M 94 12 l -8 8"/></g>
        <g className="frozen-flake f2"><path d="M 230 4 l 0 12 M 224 10 l 12 0 M 226 6 l 8 8 M 234 6 l -8 8"/></g>
        <g className="frozen-flake f3"><path d="M 350 12 l 0 12 M 344 18 l 12 0 M 346 14 l 8 8 M 354 14 l -8 8"/></g>
        <g className="frozen-flake f4"><path d="M 410 6 l 0 10 M 405 11 l 10 0"/></g>
      </g>
    </svg>
  );
}
